export default __webpack_public_path__ + "static/media/chevron-up.63db3809.svg";